import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';

const WaitlistThankYou = () => {
    const [countdown, setCountdown] = useState(10);

    // Get the public URL, defaulting to empty string for root path
    const publicUrl = process.env.PUBLIC_URL || '';

    useEffect(() => {
        // Countdown timer
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    // Redirect to vectorindia.org after 30 seconds
                    window.location.href = 'https://vectorindia.org';
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        // Cleanup timer on unmount
        return () => clearInterval(timer);
    }, []);

    return (
        <Container maxWidth="sm">
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '80vh',
                py: 4
            }}>
                {/* Logo */}
                <Box sx={{ mb: 4 }}>
                    <img
                        src={`${publicUrl}/logo-vector.svg`}
                        alt="Vector India Logo"
                        style={{ height: '80px', width: 'auto' }}
                        onError={(e) => {
                            // Fallback if logo-vector.svg doesn't load
                            e.target.src = `${publicUrl}/vector_logo.jpg`;
                        }}
                    />
                </Box>

                {/* Success Message */}
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center', width: '100%' }}>
                    <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        sx={{
                            color: '#ff8800',
                            fontWeight: 'bold',
                            mb: 2
                        }}
                    >
                        Thank You!
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 2, color: '#555555' }}>
                        Registration Successful
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, color: '#555555' }}>
                        Thank you for your interest! We will notify you when internship programs are available.
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#888888', fontStyle: 'italic' }}>
                        Redirecting to Vector India website in {countdown} seconds...
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default WaitlistThankYou;

